import { ArrowRight } from "lucide-react";
import { useDialogs } from "./DialogsContext";

export default function FinalCTA() {
  const { openAudit, openBook } = useDialogs();
  return (
    <section
      data-testid="final-cta"
      className="relative py-24 lg:py-36 border-b border-white/10 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-4 stripes" />
      <div className="absolute inset-x-0 bottom-0 h-4 stripes" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
        <div className="max-w-4xl">
          <h2 className="font-display text-5xl sm:text-7xl lg:text-[120px] uppercase leading-[0.9]">
            Stop letting <span className="text-[#ccff00]">money</span>
            <br />
            sit in your CRM.
          </h2>
          <p className="mt-8 text-lg text-white/70 max-w-xl">
            One free audit. Real revenue projections. Zero obligation. The
            worst thing that happens is you find out exactly how much you’re
            leaving behind.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="final-cta-audit"
              onClick={openAudit}
              className="group inline-flex items-center justify-center gap-2 h-14 px-8 bg-[#ccff00] text-black font-bold uppercase tracking-wider text-sm hover:bg-[#b3e600] transition-all"
            >
              Claim my free audit
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={3} />
            </button>
            <button
              data-testid="final-cta-call"
              onClick={openBook}
              className="inline-flex items-center justify-center gap-2 h-14 px-8 border border-white/20 text-white font-semibold uppercase tracking-wider text-sm hover:border-white/60 hover:bg-white/5 transition-all"
            >
              Talk to a human
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
